import React, { useState } from 'react';
import Button from './button';

const CollapsibleListItem = ({ label, action }) => {
  return <p className="App-collapsible-list-item" onClick={action} >{label}</p>
}

const CollapsibleList = ({ items, itemAction, label, icon, color, isOpen }) => {
  const [isCollapsed, setIsCollapsed] = useState(true)

  return (
    <div className="App-collapsible-list" onClick={() => setIsCollapsed(!isCollapsed)}>
      <Button label={label + (items ? " (" + items.length + ")": "")} SvgIcon={icon} color={color} />
      {(isOpen || !isCollapsed) && items && <div className="App-collapsible-list-inner">
          {items.map((i) => <CollapsibleListItem key={i.id} label={i.title} action={() => itemAction(i.id)}/>)}
        </div>
      }
    </div>
  )
}

export default CollapsibleList